/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ServiceCategoryCreateDto } from '../../models/service-category-create-dto';
import { ServiceCategory } from '../../models/service-category';

export interface ServiceControllerCreateCategory$Params {
      body: ServiceCategoryCreateDto
}

export function serviceControllerCreateCategory(http: HttpClient, rootUrl: string, params: ServiceControllerCreateCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ServiceCategory;
}>> {
  const rb = new RequestBuilder(rootUrl, serviceControllerCreateCategory.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ServiceCategory;
      }>;
    })
  );
}

serviceControllerCreateCategory.PATH = '/service/category';
